import PanelStatusBar, { PanelStatusBarProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/PanelStatusBar';
import cn from 'clsx';

import classes from './SignalStatusBar.module.scss';

const SignalStatusBar = (props: PanelStatusBarProps) => {
  const { value, ...rest } = props;

  return (
    <PanelStatusBar
      value={value}
      barClassName={cn(classes.signalBar, {
        // hack to apply mask
        [classes.translateZ0]: !!value,
      })}
      {...rest}
    />
  );
};

export default SignalStatusBar;
